import goTopButton from '@/components/GoTopButton'
import ProductErrorDialog from '@/components/ProductErrorDialog'
import SuccessDialogProduct from '@/components/SuccessDialogProduct'
import { defineRule, Form, Field, ErrorMessage, configure } from 'vee-validate';
import { required, regex } from '@vee-validate/rules';
import { setLocale, localize } from "@vee-validate/i18n";
import { getPlus1Date } from '@/tools/utils'

defineRule('required', required);
defineRule('regex', regex);

configure({
  generateMessage: localize({
    fr: {
      messages: {
        required: 'Le champ {field} est obligatoire',
        regex: 'Le format du champ {field} n\'est pas respecté'
      },
    },
    en: {
      messages: {
        required: 'The field {field} is required',
        regex: 'The format of the field {field} is not respected'
      },
    },
  }),
});

const messages = {
  fr: {
    required: 'Le champ {field} est obligatoire',
    regex: 'Le format du champ {field} n\'est pas respecté',
  },
  en: {
    required: 'The field {field} is required',
    regex: 'The format of the field {field} is not respected',
  }
};

function getLocalizedMessage(field, rule, locale) {
  const messageTemplate = messages[locale][rule];
  return messageTemplate.replace('{field}', field);
}

export default {

  components: {
    goTopButton,
    ProductErrorDialog,
    SuccessDialogProduct,
    Form,
    Field,
    ErrorMessage
  },

  data () {
    return {
      permissions: JSON.parse(sessionStorage.getItem('user')).permissions,
      responseErr: null,
      modalError: null,
      modalDescription: null,
      isProcessing: false,
      productParams: null,
      locale: null,
      product: {},
      productErrors: {},
      productStructure: null,
      updateDate: null,
      dateError: false,
      editedProductsLastMonth: null,
      editedProductsThisMonth: null,
      readingMode : {
        'MANUAL' : 'O',
        'CHIP' : 'O',
        'CHIP_CONTACTLESS' : 'O',
        'MAGSTRIPE' : 'N',
        'MAGSTRIPE_CONTACTLESS' : 'N',
        'MANUAL_MAGSTRIPE_FALLBACK' : 'N',
        'CHIP_TO_MAGSTRIPE_FALLBACK' : 'N',
        'SERVER' : 'O',
        'UNKNOWN' : 'N'
      },
      blockErrors: {
        'PRB': false,
        'PRE': false,
        'PRC': false,
        'PRS': false,
        'PRO': false,
        'PRF': false
      },
      keyValues: [
        'KPV',
        'KCVx',
        'KEMV'
      ]
    }
  },

  created () {
    const user = JSON.parse(sessionStorage.getItem('user'))
    // set locale for vee-validate error messages
    this.setVeeValidateLocale(user)

    // Retrieve number of created products for the current month and the previous month
    this.$store.dispatch('products/editedProductsLastMonth').then(
      (response) => {
        if(response.responseCode != 'SUCCESS') {
          this.editedProductsLastMonth = null
        }
        else {
          this.editedProductsLastMonth = response.numberOfProducts
        }
      },
      error => {
        this.responseErr = error || 'BAD_REQUEST'
      }
    )
    this.$store.dispatch('products/editedProductsCurrentMonth').then(
      (response) => {
        if(response.responseCode != 'SUCCESS') {
          this.editedProductsThisMonth = null
        }
        else {
          this.editedProductsThisMonth = response.numberOfProducts
        }
      },
      error => {
        this.responseErr = error || 'BAD_REQUEST'
      }
    )


    this.productParams = this.$store.state.products.product
    if (!this.productParams || !this.productParams.prb1 || !this.productParams.prb7) {
      this.$store.dispatch('products/invalidData', 'PRODUCT_EMPTY')
      this.$router.push({ name: 'product-list' })
    }
    else {
      this.$store.dispatch('products/resetInvalidData')
    }
    this.$store.dispatch('products/resetViolations')
    this.getDetail()
    this.updateDate = getPlus1Date()
  },

  methods: {
    hasPermission (permission) {
      if (!String.prototype.includes) {
        return this.permissions.indexOf(permission, 0) !== -1
      } else {
        return this.permissions.includes(permission)
      }
    },

    triggerErrorDate () {
      this.dateError = true
      document.getElementById("cardBottom").classList.remove("mb-4")
    },

    updateErrorDate () {
      if (this.updateDate === null || this.updateDate < getPlus1Date()) {
        this.triggerErrorDate();
      }
      else {
        this.dateError = false
        let elt = document.getElementById("cardBottom")
        elt.classList.add("mb-4")
      }
    },

    async getDetail () {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('products/resetDetail')
      await this.$store.dispatch('products/detail', {
        idDistributeur: this.productParams.prb7,
        idProduct: this.productParams.prb1
      }).then(
        () => {
          this.isProcessing = false
          this.getStructure()
        },
        error => {
          this.isProcessing = false
          this.responseErr = error.responseCode || error || 'BAD_REQUEST'
        }
      )
    },
    async getStructure () {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('products/resetStructure')
      await this.$store.dispatch('products/structure').then(
        () => {
          this.isProcessing = false
          this.productStructure = this.$store.state.products.structure
          this.initProduct()
        },
        error => {
          this.isProcessing = false
          this.responseErr = (error.response.data || 'BAD_REQUEST')
        }
      )
    },

    // Initialise l'objet product à renvoyer avec ses valeurs de base et formatte correctement les valeurs
    initProduct () {
      this.product['parent'] = null
      for (var i in this.productStructure) {
        this.product[this.productStructure[i].fieldName] = {}
        this.productErrors[this.productStructure[i].fieldName] = {}
        for (var j in this.productStructure[i].params) {
          this.productErrors[this.productStructure[i].fieldName][this.productStructure[i].params[j].fieldName] = null
          // Adapt regexs to be used in javascript adn having the same behavior as in Java
          let regexp = this.productStructure[i].params[j].regexp
          regexp = regexp.replaceAll('\\:', ':')
          regexp = regexp.replaceAll('[[ \\t]]', '[ \\t]')
          if(!regexp.includes('^') && !regexp.includes('$')) {
            regexp = '^' + regexp + '$'
            try {
              if(regexp.includes('[\\v')) {
                regexp = regexp.replaceAll('\\v', '\\n\\u000B\\u2028\\u2029')
              }
              else if(regexp.includes('\\v')) {
                regexp = regexp.replaceAll('\\v', '[\\n\\u000B\\u2028\\u2029]')
              }
              else if(regexp.includes('*+')) {
                regexp = regexp.replace('*+', '*')
              }
              this.productStructure[i].params[j].regexp = new RegExp(regexp, 'u')
            } catch (error) {
              console.error("Invalid regex pattern: ", error);
            }
          }
          if (this.$store.state.products.productDetail[i].params[j].value.length > 1) {
            this.product[this.productStructure[i].fieldName][this.productStructure[i].params[j].fieldName] = ''
            this.$store.state.products.productDetail[i].params[j].value.map((value) => this.product[this.productStructure[i].fieldName][this.productStructure[i].params[j].fieldName] += value + '\n')
          }
          else {
            this.product[this.productStructure[i].fieldName][this.productStructure[i].params[j].fieldName] = this.$store.state.products.productDetail[i].params[j].value[0]
          }
        }
      }

      let newProduct = {
        "product": this.product,
        "userName": JSON.parse(sessionStorage.getItem('user')).login,
        "requestDate": this.updateDate,
        "requestID": null
      }
      this.product = newProduct
    },

    onInvalidSubmit ({ results }) {
      for (const result in results) {
        if (Object.prototype.hasOwnProperty.call(results, result)) {
          if (!results[result].valid) {
            let block = result.substring(0,3).toLowerCase()
            let field = result.substring(0,3).toLowerCase() + result.substring(4)
            this.productErrors[block][field] = results[result].errors
            if(!this.blockErrors[result.substring(0,3)]) {
              this.blockErrors[result.substring(0,3)] = true
            }
          }
        }
      }
      if (this.updateDate === null || this.updateDate < getPlus1Date()) {
        this.triggerErrorDate();
      }
      else {
        this.dateError = false
        let elt = document.getElementById("cardBottom")
        elt.classList.add("mb-4")
      }
      this.responseErr = 'INVALID_FORM_PRODUCT'
    },

    updateErrors (block, field, inputValue, param) {
      this.responseErr = null
      let formattedField = field.substring(0,3).toLowerCase() + field.substring(4)
      this.productErrors[block][formattedField] = null;

      if (param.mandatory && !inputValue) {
        this.productErrors[block][formattedField] = getLocalizedMessage(param.code, 'required', this.locale);
        this.blockErrors[block.toUpperCase()] = true
      }

      if (param.regexp && inputValue
      && !new RegExp(param.regexp).test(inputValue)) {
        this.productErrors[block][formattedField] = getLocalizedMessage(param.code, 'regex', this.locale);
        this.blockErrors[block.toUpperCase()] = true
      }

      if(this.updateDate === null || this.updateDate < getPlus1Date()) {
        this.triggerErrorDate();
      }
      else {
        this.dateError = false
        let elt = document.getElementById("cardBottom")
        elt.classList.add("mb-4")
      }

      // Remove error triangle or not
      let allErrorsNull = true;
      for (const field in this.productErrors[block]) {
        if (this.productErrors[block][field] !== null) {
          allErrorsNull = false;
          break;
        }
      }
      if (allErrorsNull) {
        this.blockErrors[block.toUpperCase()] = false;
      }
    },

    setVeeValidateLocale() {
      // Do we want to be based on the locale of the user (user account) or the locale of the browser / environment ?
      if(this.$i18n.locale === 'fr') {
        setLocale('fr')
        this.locale = 'fr'
      }
      else if (this.$i18n.locale === 'en'){
        setLocale('en')
        this.locale = 'en'
      }
      else { // default to french
        setLocale('fr')
        this.locale = 'fr'
      }
    },

    onSubmit () {
      this.update()
    },

    showError (modalError, modalDescription) {
      this.$refs.productErrorDialogRef.showError(modalError, modalDescription)
    },

    showSuccess (successMsg, productCreated) {
      successMsg = this.$i18n.t(successMsg, [productCreated] )
      this.$refs.successDialogRef.showSuccess(successMsg)
    },
    async update () {
      this.isProcessing = true
      this.responseErr = null

      // put back values to null if they are empty to avoid useless checks ("")
      for(var i in this.product['product']) {
        for(var j in this.product['product'][i]) {
          if(this.product['product'][i][j] === '') {
            this.product['product'][i][j] = null
          }
          else if (this.product['product'][i][j] !== null && typeof this.product['product'][i][j] === 'string' || this.product['product'][i][j] instanceof String) {
            if(this.product['product'][i][j].endsWith('\n')) {
              this.product['product'][i][j] = this.product['product'][i][j].replace(/\n+$/, '');
            }
          }
        }
      }

      // Add empty blocks for PRL and PRA to avoid errors server-side
      let tmpProductToSend = this.product

      tmpProductToSend['product']['prl'] = {
        'prl1': null,
        'prl2': null,
        'prl3': null,
        'prl4': null,
        'prl5': null,
      }

      tmpProductToSend['product']['pra'] = {
        'pra1': null,
        'pra2': null,
        'pra3': null,
        'pra4': null,
      }

      this.$store.dispatch('products/updateProduct', {
        product: tmpProductToSend.product,
        userName: this.product.userName,
        requestDate: this.updateDate,
        requestID: null
      }).then(
        (response) => {
          this.modalDescription = null
          this.$store.dispatch('products/resetViolations')
          if(response.responseCode != 'SUCCESS') {
            if (response.violations == null) {
              this.showError(response.responseCode, response.responseMessage)
              this.modalDescription = response.responseMessage
            }
            else {
              this.showError(response.responseCode, null)
            }
            // set violations in store to display them in the modal
            this.$store.dispatch('products/setViolations', response.violations)
            this.modalError = response.responseCode || 'BAD_REQUEST'
            this.responseErr = 'INVALID_FORM_PRODUCT'
            this.isProcessing = false
          }
          else {
            this.showSuccess('label.product.updateSuccess', response.productRef)
            this.isProcessing = false
          }
        },
        error => {
          this.isProcessing = false
          this.responseErr = error || 'BAD_REQUEST'
          this.showError(this.responseErr)
        }
      )
    }

  }
}
